import React, { Component } from 'react';
import { connect } from 'react-redux';
import fileDownload from 'js-file-download';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileExport,
  faSearch,
  faEdit,
  faEye,
  faBan,
} from '@fortawesome/free-solid-svg-icons';
import { NavLink } from 'react-router-dom';
import {
 Form, Button, DatePicker, Col, Icon, message, Popconfirm ,Statistic ,Progress,Tag, Pagination,Modal
 ,Table
} from 'antd';
import Card from './Card';
import Row from './Row';
import Spacer from './Spacer';
import ServerSideTable from './DeliveryLopCard';
import Select from './Select';
import {
  fetchPickupList,
  fetchLopList,
  fetchTransmittalList,
  deleteDispatch,
  setPackageRemarks,
  fetchOptions,
  fetchOptionsLike,
} from '../pages/ducks';

export class DeliveryLopList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        outsource: [],
        port_code:[],
        courier:[],
        statuses: [{value:'delivery_successful',label:'delivery_successful'}, {value:'first_delivery_attempt',label:'first_delivery_attempt'}, {value:'redelivery_attempt', label:'redelivery_attempt'},{value:'failed_delivery_return', label:'failed_delivery_return'},{value:'redelivery_attempt_failed',label:'redelivery_attempt_failed'},{value:'first_attempt_failed', label:'first_attempt_failed'}],
      },
      runsheetModalVisible: false,
      runsheetData: null,
      noDocumentsShow: false,
      documentPackage: null,
      packageDocumentNote: "",
      selectedPortCode: null,
      selectedOutSource: null,
      selectedStatus: null,
      selectedCourier: null,
      showDocumentValiditySuccess: false,
      selectedDocuments: [], // to hold the URLs of the clicked package
      dispatchList: {
        rows: [],
        total: 0,
        pages: 0,
        stats: {}
      },
      isFetching: {
        location: false,
        outsource: false
      },
      dateFilter: [],
      isFetching: false,
      resTablePayload: {},
      isDisabledButton: false,
      current: 0,
      page: 0,
      pageSize: 10,
      getStats: 0,
      hasMore: true
    };
    this.selectOptions = ['outsource', 'port_code','courier'];
    this.onFetchData = this.onFetchData.bind(this);
    this.searchOption = this.searchOption.bind(this);
    this.datePickerFilterHandler = this.datePickerFilterHandler.bind(this);
    this.applyDateFilterHandler = this.applyDateFilterHandler.bind(this);
    this.cancelHandler = this.cancelHandler.bind(this);
    this.inArray = this.inArray.bind(this);
  }
openDocumentsModal = (pkg,documents) => {
  if(documents.length === 0){
    this.setState({
    noDocumentsShow: true,
  });
  }else{
    this.setState({
    documentsModalVisible: true,
    selectedDocuments: documents || [],
    documentPackage: pkg,
  });
  }
  
};

closeDocumentsModal = () => {
  this.setState({
    documentsModalVisible: false,
    selectedDocuments: [],
  });
};
closeNoDocuments = () => {
  this.setState({
    noDocumentsShow: false,
  });
};
closeDocumentValiditySuccess = () =>{
this.setState({
    showDocumentValiditySuccess: false,
  });
};
  // eslint-disable-next-line no-unused-vars
  openRunsheetModal = (data) => {
  console.log(data);
  this.setState({
    runsheetModalVisible: true,
    runsheetData: data
  });
};
closeRunsheetModal = () => {
  this.setState({
    runsheetModalVisible: false,
    runsheetData: null
  });
};
  setPackageValidity(validity,note){
    const {dosetPackageRemarks} = this.props;
    if(note.length > 0){
      validity = validity + " " + note;
    }
    const params = {
      tracking_number: this.state.documentPackage.tracking_number,
      remarks: validity
    };
    dosetPackageRemarks(params).then((action)=>{
      const code = action.payload.data.code;
      if(code == 200){
        this.state.documentPackage.remarks = validity;
        this.setState({
        runsheetData: {...this.state.runsheetData},
        packageDocumentNote: '',
        showDocumentValiditySuccess: true,
      });
      }
    });
  }
  searchOption(type, e) {
    const { doFetchOptionsLike } = this.props;

    this.setState({
      isFetching: true,
    });

    doFetchOptionsLike(type, e).then((action) => {
      this.setState(prev => ({
        isFetching: { ...prev.isFetching, [type]: true }
      }));
      this.setState(prevState => ({
        options: {
          ...prevState.options,
          [type]: action.payload.data.slice(0, 50),
        },
      isFetching: { ...prevState.isFetching, [type]: false }
      }));
    });
  }
  onFetchData(state, instance) {
    const { dateFilter, dispatchList, selectedOutSource, selectedPortCode, selectedStatus, selectedCourier } = this.state;
   
  const {
    doFetchLopList,
    dofetchOptions,
    dofetchOptionsLike,
    typeDispatch,
  } = this.props;

  const dispatchType = [{ id: 'type', value: typeDispatch }];
  const osFilter = [{id:'outsource', value: selectedOutSource}];
  const portCodeFilter = [{id:'port_code', value: selectedPortCode}];
  const statusFilter = [{id:'status', value: selectedStatus}];
  const courierFilter = [{id:'courier', value: selectedCourier}];


  if(dateFilter.length == 0){
    const today = new Date();
  const formattedDate = today.toISOString().split('T')[0]; //
    dateFilter[0] = {id:"dateFrom",value: formattedDate + " 00:00:00"};
    dateFilter[1] = {id:"dateTo",value: formattedDate + " 23:59:59"};
    //  dateFilter[0] = {id:"dateFrom",value: "2025-10-01 00:00:00"};
    // dateFilter[1] = {id:"dateTo",value: "2025-11-01 00:00:00"};
  }
  const params = {
    export: false,
    page: state.page,
    pageSize: state.pageSize,
    filter: [...state.filtered, ...dateFilter, ...dispatchType, ...osFilter, ...portCodeFilter, ...statusFilter, ...courierFilter],
    sorted: state.sorted,
    getStats: state.getStats
  };
  this.setState({ isFetching: true });

  const request = doFetchLopList(params);

  request.then((action) => {

    const newRows = action.payload.data.rows;
    const newStats = action.payload.data.stats;
    this.setState(prev => ({
      dispatchList: {
        rows: [...prev.dispatchList.rows, ...newRows],
        total: action.payload.data.total,
        pages: action.payload.data.pages,
        stats: newStats != null ? newStats : prev.dispatchList.stats
      },
      isFetching: false,
      page: state.page,
      getStats: 0,
      hasMore: newRows.length > 0
    }));

  });

  }
  componentDidMount() {
    const {
      doFetchOptions,
    } = this.props;
    const selectOptions = this.selectOptions;
  this.onFetchData({
    page: 0,
    pageSize: this.state.pageSize,
    filtered: [],
    sorted: [],
    getStats: 1
  });

  window.addEventListener("scroll", this.handleScroll);
  Object.keys(selectOptions).forEach((key) => {
      doFetchOptions(selectOptions[key]).then((action) => {
        this.setState(prevState => ({
          options: {
            ...prevState.options,
            [selectOptions[key]]: (selectOptions[key] === 'outsource' ? action.payload.data : action.payload.data.slice(0, 50)),
          },
        }));
      });
    });
}
componentWillUnmount() {
  window.removeEventListener("scroll", this.handleScroll);
}
handleScroll = () => {

  const { isFetching, hasMore, page, pageSize, options } = this.state;

  if (isFetching || !hasMore) return;

  if (
    window.innerHeight + document.documentElement.scrollTop
    >= document.documentElement.offsetHeight - 200
  ) {

    const nextPage = page + 1;

    this.onFetchData({
      page: nextPage,
      pageSize: pageSize,
      filtered: [],
      sorted: []
    });

  }

};
  inArray(userId, ids) {
    var id = ids.length;
    for(var i = 0; i < id; i++) {
      if(ids[i] == userId) return true;
    }
    return false;
  }

  exportFileList() {
    const { dateFilter, resTablePayload } = this.state;
    const { doFetchLopList, dispatchExportName } = this.props;

    this.setState({
      isDisabledButton: true,
      isFetching: true,
    });

    const params = {
      export: true,
      page: resTablePayload.page,
      pageSize: resTablePayload.pageSize,
      filter: [...resTablePayload.filter, ...dateFilter],
      sorted: resTablePayload.sorted,
    };

    doFetchLopList(params).then((res) => {
      const newBlob = new Blob([res.payload.data]);
      fileDownload(newBlob, `${dispatchExportName}-Dispatch.csv`);
      this.setState({
        isDisabledButton: false,
        isFetching: false,
      });
    });
  }

  datePickerFilterHandler(dateStrings) {
    const newDateOne = dateStrings[0];
    const newDateTwo = dateStrings[1];
    const formatDateOne = format(newDateOne, 'YYYY-MM-DD HH:mm:ss');
    const formatDateTwo = format(newDateTwo, 'YYYY-MM-DD HH:mm:ss');
    this.setState({
      dateFilter: [
        formatDateOne !== 'Invalid Date'
          ? { id: 'dateFrom', value: formatDateOne }
          : { id: 'dateFrom' },
        formatDateTwo !== 'Invalid Date'
          ? { id: 'dateTo', value: formatDateTwo }
          : { id: 'dateTo' },
      ],
    });
  }

  applyDateFilterHandler() {
    const { dateFilter } = this.state;

    const params = {
      page: 0,
      pageSize: 10,
      filtered: [],
      sorted: [],
      getStats: 1,
    };

    if (dateFilter.length === 2) {
        this.setState(prev => ({
        dispatchList: {
          rows: [],
          total: 0,
          pages: 0
        },
      }));
      this.setState(() => {
        this.onFetchData(params);
      });
    } else {
      message.warning('Please select date range!');
    }
  }

  cancelHandler(dispatchId) {
    const { resTablePayload } = this.state;
    const { doDeleteDispatch } = this.props;
    const params = {
      export: false,
      page: resTablePayload.page,
      pageSize: resTablePayload.pageSize,
      filtered: resTablePayload.filter,
      sorted: resTablePayload.sorted,
    };
    doDeleteDispatch(dispatchId)
      .then(() => {
        this.onFetchData(params);
        message.success('Successfully deleted dispatch!');
      })
      .catch(() => {
        message.error('Something went wrong, please try again later.');
      });
  }

  render() {
    const { dispatchList, isFetching, isDisabledButton, current,options } = this.state;
    const {
      fetchText,
      isCustomerMerchantPickUp,
      urlEndpoint,
      isTransmittal,
      user,
    } = this.props;
    const { RangePicker } = DatePicker;
    return (
      <div className="DispatchList">
        <Card title="List Filter">
          <Row>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item label="Port Code"
                              initialValue={"ABPLN"} 
                              >
                                {(
                                  <Select
                                    style={{ width: '100%' }}
                                    allowClear
                                    showSearch
                                    loading={isFetching.port_code}
                                    filterOption={false}
                                    onSearch={e => this.searchOption('port_code', e)}
                                    options={options.port_code}
                                    placeholder="Select port code"
                                    name="port_code"
                                    onChange={(value) => {
                                      this.setState({ selectedPortCode: value }); // store in state if needed
                                    }}
                                  />
                                )}
                              </Form.Item>
            </Col>
          <Col xs={24} sm={12} lg={6}>
                              <Form.Item label="Outsource Group"
                              >
                                {(
                                  <Select
                                    style={{ width: '100%' }}
                                    allowClear
                                    showSearch
                                    loading={isFetching.outsource}
                                    filterOption={false}
                                    onSearch={e => this.searchOption('outsource', e)}
                                    options={options.outsource}
                                    placeholder="Select outsource group"
                                    name="outsource"
                                    onChange={(value) => {
                                      this.setState({ selectedOutSource: value }); // store in state if needed
                                    }}
                                  />
                                )}
                              </Form.Item>
                              </Col>
                              <Col xs={24} sm={12} lg={6}>
                              <Form.Item label="Status"
                              >
                                {(
                                  <Select
                                    style={{ width: '100%' }}
                                    allowClear
                                    showSearch
                                    filterOption={false}
                                    options={options.statuses}
                                    placeholder="Select status"
                                    name="status"
                                    onChange={(value) => {
                                      this.setState({ selectedStatus: value }); // store in state if needed
                                    }}
                                  />
                                )}
                              </Form.Item>
                              </Col>
                                <Col xs={24} sm={12} lg={6}>
            <Form.Item label="Courier"
                >
                  {(
                    <Select
                      style={{ width: '100%' }}
                      allowClear
                      showSearch
                      loading={isFetching.courier}
                      filterOption={false}
                      onSearch={e => this.searchOption('courier', e)}
                      options={options.courier}
                      placeholder="Select courier"
                      name="courier"
                      onChange={(value) => {
                        this.setState({ selectedCourier: value }); // store in state if needed
                      }}
                    />
                  )}
                </Form.Item>
            </Col>
                              
                              
          </Row>
          {/* <Row>
            <Col xs={24} sm={12} lg={8}>
            <Form.Item label="Courier"
                >
                  {(
                    <Select
                      style={{ width: '100%' }}
                      allowClear
                      showSearch
                      loading={isFetching.courier}
                      filterOption={false}
                      onSearch={e => this.searchOption('courier', e)}
                      options={options.courier}
                      placeholder="Select courier"
                      name="courier"
                      onChange={(value) => {
                        this.setState({ selectedCourier: value }); // store in state if needed
                      }}
                    />
                  )}
                </Form.Item>
            </Col>
          </Row> */}
          <Row>
            <Col>
              <Form.Item label="Date Range">
                <RangePicker
                  style={{ width: '100%' }}
                  onChange={e => this.datePickerFilterHandler(e)}
                  showTime={{
                    hideDisabledOptions: true,
                    defaultValue: [
                      moment('00:00', 'HH:mm'),
                      moment('00:00', 'HH:mm'),
                    ],
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          
          <Row>
            <Col>
              <Button
                type="primary"
                htmlType="submit"
                block
                onClick={this.applyDateFilterHandler}
              >
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faSearch} fixedWidth />
                </Icon>
                Search
              </Button>
            </Col>
          </Row>
          <br></br><br></br><br></br>
          <Row gutter={24} justify="center" style={{ marginTop: 20 }}>
            <Col xs={24} md={8} style={{ textAlign: "center" }}>
              <Statistic
                title="Total Couriers"
                value={dispatchList.stats ? dispatchList.stats.couriers : 0}
                valueStyle={{ fontSize: 32 }}
              />
            </Col>

            <Col xs={24} md={8} style={{ textAlign: "center" }}>
              <Statistic
                title="Total Deliveries"
                value={dispatchList.stats ? dispatchList.stats.total : 0}
                suffix={ dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round(((dispatchList.stats.delivery_successful/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"}
                valueStyle={{ fontSize: 32 }}
              />
            </Col>

            <Col xs={24} md={8} style={{ textAlign: "center" }}>
              <Statistic
                title="Total Return FD"
                 value={dispatchList.stats ? dispatchList.stats.failed_delivery_return : 0}
                suffix={ dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round(((dispatchList.stats.failed_delivery_return/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"}
                valueStyle={{ fontSize: 32 }}
              />
            </Col>
          </Row>
  <Row style={{ marginTop: 30, marginBottom: 10 }}>
    <Col span={24}>
      <div style={{ 
        display: 'flex', 
        width: '100%', 
        height: '24px', 
        backgroundColor: '#bdc3c7', // Default Pending color
        borderRadius: '4px', 
        overflow: 'hidden' 
      }}>
        {/* Successful Segment (Green) */}
        <div style={{ 
          width: dispatchList.stats ? dispatchList.stats.total > 0 ? `${(dispatchList.stats.delivery_successful / dispatchList.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#72c424' 
        }} />

        {/* Failed Attempts Segment (Yellow) */}
        <div style={{ 
          width: dispatchList.stats ? dispatchList.stats.total > 0 ? `${((dispatchList.stats.redelivery_attempt_failed + dispatchList.stats.first_attempt_failed) / dispatchList.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#facb26' 
        }} />

        {/* Failed Segment (Orange) */}
        <div style={{ 
          width: dispatchList.stats ? dispatchList.stats.total > 0 ? `${(dispatchList.stats.failed_delivery_return / dispatchList.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#ed4f27' 
        }} />

        {/* The remaining space automatically shows the background (Pending/Grey) */}
      </div>
    </Col>
  </Row>
        <Row gutter={24} justify="center" style={{ marginTop: 15, fontSize: 14 }}>
  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#72c424', fontSize: 18 }}>●</span> {dispatchList.stats ? dispatchList.stats.delivery_successful: 0} Successful { dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round(((dispatchList.stats.delivery_successful/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"} 
  </Col>

  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#facb26', fontSize: 18 }}>●</span> {dispatchList.stats ?  dispatchList.stats.redelivery_attempt_failed + dispatchList.stats.first_attempt_failed: 0} Failed Attempts { dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round((((dispatchList.stats.redelivery_attempt_failed + dispatchList.stats.first_attempt_failed)/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>

  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#ed4f27', fontSize: 18 }}>●</span> {dispatchList.stats ? dispatchList.stats.failed_delivery_return: 0} Failed { dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round(((dispatchList.stats.failed_delivery_return/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>

  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#bdc3c7', fontSize: 18 }}>●</span> {dispatchList.stats ? dispatchList.stats.first_delivery_attempt + dispatchList.stats.redelivery_attempt: 0} Pending { dispatchList.stats ? dispatchList.stats.total > 0 ? Math.round((((dispatchList.stats.first_delivery_attempt + dispatchList.stats.redelivery_attempt)/dispatchList.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>
</Row>
        </Card>
        <Spacer />{
        }
        <Card
        
          // extra={`Total: ${dispatchList.total
          //   .toString()
          //   .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
            
        >
          
          <div className="DispatchCards" style={{ padding: '20px 0' }}>
  {dispatchList.rows.map((row,index) => (
        <Card 
          key={row.dh_id || row.id} 
          style={{ marginBottom: 16, borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}
          actions={[
            <NavLink to={`${urlEndpoint}/${isCustomerMerchantPickUp ? row.ph_id : row.dh_id}`}>
              <Button type="link"><FontAwesomeIcon icon={faEye} /> View</Button>
            </NavLink>,
            (row.status === 'new' || isCustomerMerchantPickUp) && (
              <NavLink to={`${urlEndpoint}/edit/${isCustomerMerchantPickUp ? row.ph_id : row.dh_id}`}>
                <Button type="link"><FontAwesomeIcon icon={faEdit} /> Edit</Button>
              </NavLink>
            )
          ].filter(Boolean)}
        >
          <Card
  style={{
    borderRadius: 8,
    marginBottom: 16
  }}
>
  <Row align="middle" gutter={16}>

    {/* Driver Info */}
    <Col span={5}>
      <div style={{ fontWeight: 600, color: "#1677ff" }}>
        {row.packages[0].firstname + " " + row.packages[0].lastname}
      </div>{row.packages[0].mobile_no}
      <div style={{ fontSize: 12, color: "#888" }}>
        {row.stats.total > 0 ? Math.round(row.stats.completed/row.stats.total  * 100): 0 }% completed of {row.stats.total}
      </div>
    </Col>

    {/* Button */}
<Col span={3} style={{ position: "relative", zIndex: 10 }}>
      <Button type="primary" ghost size="small"
        onClick={() => this.openRunsheetModal(row)}

      >
        Dispatch Details
      </Button>
    </Col>

    <Col>
    <Row style={{ marginTop: 30, marginBottom: 10 }}>
    <Col span={12}>
      <div style={{ 
        display: 'flex', 
        width: '100%', 
        height: '10px', 
        backgroundColor: '#bdc3c7', // Default Pending color
        borderRadius: '4px', 
        overflow: 'hidden' 
      }}>
        {/* Successful Segment (Green) */}
        <div style={{ 
          width: row.stats.delivery_successful ? row.stats.total > 0 ? `${(row.stats.delivery_successful / row.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#72c424' 
        }} />

        {/* Failed Attempts Segment (Yellow) */}
        <div style={{ 
          width: row.stats ? row.stats.total > 0 ? `${((row.stats.redelivery_attempt_failed + row.stats.first_attempt_failed) / row.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#facb26' 
        }} />

        {/* Failed Segment (Orange) */}
        <div style={{ 
          width: row.stats ? row.stats.total > 0 ? `${(row.stats.failed_delivery_return / row.stats.total) * 100}%` : "0%" : "0%", 
          backgroundColor: '#ed4f27' 
        }} />

        {/* The remaining space automatically shows the background (Pending/Grey) */}
      </div>
      <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#72c424', fontSize: 10 }}>●</span> {row.stats ? row.stats.delivery_successful: 0} Successful { row.stats ? row.stats.total > 0 ? Math.round(((row.stats.delivery_successful/row.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>

  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#facb26', fontSize: 10 }}>●</span> {row.stats ?  row.stats.redelivery_attempt_failed + row.stats.first_attempt_failed: 0} Failed Attempts { row.stats ? row.stats.total > 0 ? Math.round((((row.stats.redelivery_attempt_failed + row.stats.first_attempt_failed)/row.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>

  <Col span={6} style={{ textAlign: "center" }}>
    <span style={{ color: '#ed4f27', fontSize: 10 }}>●</span> {row.stats ? row.stats.failed_delivery_return: 0} Failed { row.stats ? row.stats.total > 0 ? Math.round(((row.stats.failed_delivery_return/row.stats.total) * 100)) + "%" : "0%" : "0%"}
  </Col>

      <Col span={6} style={{ textAlign: "center" }}>
        <span style={{ color: '#bdc3c7', fontSize: 10 }}>●</span>  {row.stats ? row.stats.first_delivery_attempt + row.stats.redelivery_attempt: 0} Pending { row.stats ? row.stats.total > 0 ? Math.round((((row.stats.first_delivery_attempt + row.stats.redelivery_attempt)/row.stats.total) * 100)) + "%" : "0%" : "0%"}
      </Col>
    </Col>
    {/* Checkout */}
    <Col span={3}>
      <div style={{ fontSize: 12 }}>
        Checkout:
        <br />
        <b>{row.packages[0].dispatch_date}</b>
      </div>
    <div style={{ fontSize: 12 }}>
        Last Activity Log:
        <br />
        <b>
          {row.packages && row.packages.length
            ? (() => {
                const latest = row.packages.reduce((latest, current) =>
                  current.updated_at > latest.updated_at ? current : latest
                );
                return `${latest.updated_at}`;
              })()
            : ""}
        </b>
      </div>
    </Col>
  </Row>
    </Col>


    



  </Row>
</Card>
          
        </Card>
      ))}{isFetching && (
            <div style={{ textAlign: 'center', padding: 20 }}>
              Loading more deliveries...
            </div>
          )}
      <Modal
  title="Dispatch Details"
  visible={this.state.runsheetModalVisible}
  onCancel={this.closeRunsheetModal}
  footer={null}
  width={1200}
>
  {this.state.runsheetData && (
    <>
      <Row gutter={16} style={{ marginBottom: 20 }}>
        <Col span={4}>
          <Statistic
            title="Successful"
            value={this.state.runsheetData.stats.delivery_successful}
          />
        </Col>

        <Col span={4}>
          <Statistic
            title="Failed Attempt"
            value={this.state.runsheetData.stats.redelivery_attempt_failed + this.state.runsheetData.stats.first_attempt_failed}
          />
        </Col>

        <Col span={4}>
          <Statistic
            title="Failed Return"
            value={this.state.runsheetData.stats.failed_delivery_return}
          />
        </Col>

        <Col span={4}>
          <Statistic
            title="Total TN's"
            value={this.state.runsheetData.stats.total}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Total Drops"
            value={this.state.runsheetData.stats.total_drops_count}
          />
        </Col>
        <Col span={4}>
          <Statistic
            title="Total CWT"
            value={this.state.runsheetData.stats.total_cwt}
          />
        </Col>
      </Row>

      <Table
  rowKey="dh_id"
  dataSource={this.state.runsheetData.packages}
  pagination={false}
  size="small"
  columns={[
    {
      title: "DM",
      dataIndex: "dh_id",
      render: (value, row, index) => {
        const data = this.state.runsheetData.packages;
        if (index > 0 && data[index - 1].dh_id === value) {
          return "";
        }
        return value;
      }
    },
    {
      title: "Tracking",
      dataIndex: "tracking_number",
    },
    {
      title: "Address",
      dataIndex: "consignee_address",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => <Tag>{status === 'first_attempt_failed' || status === 'redelivery_attempt_failed' ? <a style={{color:'#facb26'}}>{status}</a> :
      status === 'delivery_successful' ? <a style={{color:'#72c424'}}>{status}</a> : status === 'failed_delivery_return' ? <a style={{color:'#ed4f27'}}>{status}</a> : <a>{status}</a>} </Tag>,
    },
    {
      title: "Reference Code",
      dataIndex: "log_reference_code",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
    },
    {
      // title: "Added",
      // dataIndex: "added_at",
      title: "Updated",
      dataIndex: "updated_at",
    },
    {
      title: "Documents",
      dataIndex: "documents",
      render: (documents,record) => (
        <Button
          type="link"
          onClick={() => this.openDocumentsModal(record,documents)}
        >
          View Documents
        </Button>
      ),
    },
  ]}
/>
    </>
  )}
</Modal>
<Modal
  title="Package Documents"
  visible={this.state.documentsModalVisible}
  onCancel={this.closeDocumentsModal}
  footer={null}
  width={800}
>
  <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
    {this.state.selectedDocuments.map((doc, idx) => (
      <div key={idx} style={{ width: "30%", textAlign: "center" }}>
        <img
          src={doc.url}
          alt={`Document ${idx + 1}`}
          style={{ width: "100%", borderRadius: 4, marginBottom: 5 }}
        />
        <a href={doc.url} target="_blank" rel="noopener noreferrer">
          Open
        </a>
      </div>
    ))}
  </div>

  {/* Footer */}
  <div
    style={{
      marginTop: 20,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 10,
      borderTop: "1px solid #f0f0f0",
      paddingTop: 15
    }}
  >
    {/* Editable Text Input */}
    <input
      type="text"
      placeholder="Enter note"
      value={this.state.packageDocumentNote || ""}
      onChange={(e) => this.setState({ packageDocumentNote: e.target.value })}
      style={{
        padding: "6px 12px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        flexGrow: 1,
        maxWidth: 300
      }}
    />

    <button
      style={{
        padding: "6px 16px",
        borderRadius: 4,
        border: "1px solid #d9d9d9",
        background: "#fff",
        cursor: "pointer"
      }}
      onClick={() =>
        this.setPackageValidity("Invalid EPODs", this.state.packageDocumentNote)
      }
    >
      Invalid
    </button>

    <button
      style={{
        padding: "6px 16px",
        borderRadius: 4,
        border: "none",
        background: "#1890ff",
        color: "#fff",
        cursor: "pointer"
      }}
      onClick={() =>
        this.setPackageValidity("Valid EPODs", this.state.packageDocumentNote)
      }
    >
      Valid
    </button>
  </div>
</Modal>
<Modal
  title="Warning!"
  visible={this.state.noDocumentsShow}
  onCancel={this.closeNoDocuments}
  footer={null}

>
  <p>No EPODS</p>
</Modal>
<Modal
  title="Success!"
  visible={this.state.showDocumentValiditySuccess}
  onCancel={this.closeDocumentValiditySuccess}
  footer={null}

>
  <p>Validity has been setWindowDimensions</p>
</Modal>
      {/* Custom Pagination Footer to replace the table footer */}
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        
      </div>
    </div>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

DeliveryLopList.defaultProps = {
  isCustomerMerchantPickUp: false,
  isTransmittal: false,
};

DeliveryLopList.propTypes = {
  form: PropTypes.oneOfType([PropTypes.object]).isRequired,
  dispatchExportName: PropTypes.string.isRequired,
  hasExport: PropTypes.bool.isRequired,
  user: PropTypes.oneOfType([PropTypes.object]).isRequired,
  isCustomerMerchantPickUp: PropTypes.bool,
  isTransmittal: PropTypes.bool,
  typeDispatch: PropTypes.string.isRequired,
  fetchText: PropTypes.string.isRequired,
  urlEndpoint: PropTypes.string.isRequired,
  dispatchListColumns: PropTypes.oneOfType([PropTypes.array]).isRequired,
  doFetchPickupList: PropTypes.func.isRequired,
  doFetchLopList: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
  doFetchOptionsLike: PropTypes.func.isRequired,
  dosetPackageRemarks: PropTypes.func.isRequired,
  doFetchTransmittalList: PropTypes.func.isRequired,
  doDeleteDispatch: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchPickupList: fetchPickupList,
  doFetchLopList: fetchLopList,
  doFetchOptions:fetchOptions,
  doFetchOptionsLike:fetchOptionsLike,
  dosetPackageRemarks: setPackageRemarks,
  doFetchTransmittalList: fetchTransmittalList,
  doDeleteDispatch: deleteDispatch,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryLopList);
